import OffersList from './OffersList';

export default OffersList;
